import type { CSSProperties, SVGProps } from 'react'
import classes from './icon.module.css'

type Props = SVGProps<SVGSVGElement> & {
  className?: string
  style?: CSSProperties
}
export function Expand(props: Props) {
  const { className, style, ...rest } = props

  const cls = `${classes.root} ${className || ''}`
  return (
    <svg
      aria-hidden="true"
      className={cls}
      focusable="false"
      viewBox="0 0 24 24"
      {...rest}
      data-testid="Expand"
      style={style}
    >
      <path d="M12 5.83 15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15z" />
    </svg>
  )
}
